import { lazy } from 'react';

export const SubLayouts = {
  account: lazy(() => import('ui/organisms/Layout/AccountLayout')),
  programs: lazy(() => import('ui/organisms/ProgramsLayout/ProgramsLayout')),
  events: lazy(() => import('ui/organisms/ProgramsLayout/ProgramsLayout')),
  'q-and-a': lazy(() => import('ui/organisms/QALayout')),
  // watch: lazy(() => import('features/watch/components/organisms/WatchLayout/WatchLayout')),
};
